var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "collection" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row center-xs" }, [
        _c("header", { staticClass: "col-md-12" }, [
          _c("h3", { staticClass: "align-left cl-accent h3 m0" }, [
            _vm._v("\n          " + _vm._s(_vm.title) + "\n        ")
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "collection-slider" }, [
      _c("div", { staticClass: "container px15" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-12" }, [
            _c(
              "div",
              { staticClass: "center-xs cool-stuff-collection" },
              [
                _c(
                  "no-ssr",
                  [
                    _c(
                      "carousel",
                      _vm._b(
                        { on: { pageChange: _vm.setMuted } },
                        "carousel",
                        _vm.config,
                        false
                      ),
                      _vm._l(_vm.products, function(product) {
                        return _c(
                          "slide",
                          {
                            key: product.id,
                            attrs: { categoryProps: product.catalog }
                          },
                          [
                            _c("product-tile", {
                              staticClass: "collection-product",
                              attrs: {
                                product: product,
                                categoryProps: product.catalog,
                                "labels-active": false,
                                "only-image": false,
                                showStatus: _vm.showStatus,
                                isBadge: _vm.isBadge,
                                isH4: _vm.isH4
                              }
                            })
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }